// controllers/form/input/autoresize_controller.js
import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    if (CSS?.supports?.("field-sizing: content")) return;

    this.textarea = this.element.querySelector('textarea')
    this.textarea.addEventListener('input', this.#update)
    this.#update({currentTarget: this.textarea})
  }

  #update({currentTarget}) {
    currentTarget.parentNode.dataset.content = currentTarget.value
  }
}